/**
 * Client invites inside the Design Check app — sales and admin only.
 * Reuses the shared InvitePanel; the server enforces the same roles on
 * every /api/design-check/admin/* call.
 */

import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import DesignCheckLayout from './DesignCheckLayout';
import InvitePanel from '../../components/design-check/InvitePanel';
import './DesignCheck.css';

const ALLOWED_ROLES = ['admin', 'sales'];

function InvitesPage() {
  const [message, setMessage] = useState(null); // { text, type }
  const role = localStorage.getItem('userRole');

  if (!ALLOWED_ROLES.includes(role)) {
    return <Navigate to="/design-check" replace />;
  }

  const showMessage = (text, type = 'info') => {
    setMessage({ text, type });
    setTimeout(() => setMessage(null), 4000);
  };

  return (
    <DesignCheckLayout>
      {message && (
        <div
          className={message.type === 'error' ? 'dc-error-banner' : 'dc-info-banner'}
          style={{ maxWidth: 1100, margin: '0 auto 16px' }}
        >
          {message.text}
        </div>
      )}
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <InvitePanel showMessage={showMessage} />
      </div>
    </DesignCheckLayout>
  );
}

export default InvitesPage;
